module.exports = __webpack_public_path__ + "public/img/teacher_wx.c3533d6b.png";